export default {
  addUserAgent() {
    $("html").attr("data-agent", navigator.userAgent);
  },

  print() {
    $(".print_page").click((e) => {
      e.preventDefault();
      window.print();
    });
  },
};
